export function stickyHeader() {
  if (document.querySelector(".announcement-bar-section")) {
    var stickNavBar = function stickNavBar() {
      var heigthBar = bar.offsetHeight;
      var header = document.querySelector(".header-wrapper");
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      var heigthHeader = header.offsetHeight;
      var actPDP = document.querySelector(".section-stickyProductNav");
      bar.style.position = "sticky";
      bar.style.top = "0px";
      bar.style.transition = "transform, top 0.1s ease-out";
      bar.style.zIndex = "100";
      header.style.transition = "transform, top 0.15s ease-out";
      if (scrollTop > previousPosition) {
        // Scrolling down
        header.style.top = "0px";
        if (scrollTop < heigthBar + heigthHeader) {
          // Near the top of the page
          bar.style.position = "static";
          header.style.position = "static";
          if (actPDP) {
            actPDP.style.display = "block";
          }
        } else {
          bar.style.position = "sticky";
          bar.style.top = "-".concat(heigthBar, "px");
          header.style.position = "sticky";
          header.style.top = "-".concat(heigthHeader, "px");
        }
      } else if (scrollTop < previousPosition) {
        // Scrolling up
        if (scrollTop == 0) {
          // At top page
          header.style.position = "sticky";
          header.style.top = "0px";
        } else if (scrollTop < heigthBar + heigthBar) {
          // Near the top of the page
          header.style.position = "sticky";
          header.style.top = "".concat(heigthBar, "px");
          if (actPDP) {
            actPDP.style.display = "none";
          }
        } else {
          bar.style.transform = "0px";
          header.style.top = "0px";
          header.style.top = "".concat(heigthBar, "px");
        }
        if (actPDP) {
          actPDP.style.top = "".concat(parseFloat(actPDP.style.top) + heigthBar, "px");
        }
      }
      previousPosition = scrollTop;
    };
    window.onscroll = function () {
      stickNavBar();
    };
    var bar = document.querySelector(".announcement-bar-section");
    var previousPosition = window.pageYOffset || document.documentElement.scrollTop;
  }
}